export const gitCommit = 'cb42d4ed'
